var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import BaseWidget from '../BaseWidget';
import WebsiteNavigator from './WebsiteNavigator';
import WebsiteNavigatorMobileView from './WebsiteNavigatorMobileView';
import ClassNames from './WebsiteNavigator.less';
import MediaQuery from 'react-responsive';
import { HAMBURGER, HORIZONTAL } from './Constants';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* Generic website navigator widget for displaying navigation on
* a website.
*/
var WebsiteNavigatorWidget = /** @class */ (function (_super) {
    __extends(WebsiteNavigatorWidget, _super);
    function WebsiteNavigatorWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebsiteNavigatorWidget.prototype.shouldComponentUpdate = function (nextProps) {
        return !isEqual(this.props, nextProps);
    };
    WebsiteNavigatorWidget.prototype.getStyleObject = function () {
        var containerStyles = _super.prototype.getStyleObject.call(this);
        var backgroundColor = containerStyles.container.backgroundColor && containerStyles.container.backgroundColor !== 'transparent' ? containerStyles.container.backgroundColor : this.getParentBackground().backgroundColor;
        var pageLinks = this.getElementInlineStyle('pageLinks');
        return __assign(__assign({}, containerStyles), { navigation: {
                textAlign: this.getElementText('pageLinks').textAlign
            }, pageLinks: pageLinks, header: __assign(__assign({}, pageLinks), { textAlign: 'left' }), verticalMenu: {
                backgroundColor: backgroundColor
            }, subMenu: {
                backgroundColor: backgroundColor
            } });
    };
    WebsiteNavigatorWidget.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, config = _a.config, selectedPage = _a.selectedPage, pageData = _a.pageData, navigateToPage = _a.navigateToPage, hideNavigationMenu = _a.hideNavigationMenu, openNavigatorDialog = _a.openNavigatorDialog, closeNavigatorDialog = _a.closeNavigatorDialog, leftContent = _a.leftContent, rightContent = _a.rightContent, translate = _a.translate, style = _a.style;
        var pageLinksArrangement = config.shared.pageLinksArrangement;
        return React.createElement(MediaQuery, { query: "only screen and (max-width: 30em)" }, function (matches) {
            var Component = matches ? WebsiteNavigatorMobileView : WebsiteNavigator;
            return React.createElement(Component, __assign({}, resolveTestId(_this.props), { selectedPage: selectedPage, hideNavigationMenu: hideNavigationMenu, pageData: pageData, navigateToPage: navigateToPage, openNavigatorDialog: openNavigatorDialog, closeNavigatorDialog: closeNavigatorDialog, pageLinksArrangement: pageLinksArrangement, leftContent: leftContent, rightContent: rightContent, classes: classes, translate: matches ? translate : null, style: _this.getStyleObject(), dimensions: style.dimensions }));
        });
    };
    WebsiteNavigatorWidget.displayName = 'WebsiteNavigatorWidget';
    WebsiteNavigatorWidget.propTypes = {
        config: PropTypes.shape({
            shared: PropTypes.shape({
                pageLinksArrangement: PropTypes.oneOf([HORIZONTAL, HAMBURGER])
            })
        }),
        classes: PropTypes.object,
        style: PropTypes.object,
        translate: PropTypes.func,
        // Non-configurable props that should be added by the application specific wrapper.
        selectedPage: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string
        }),
        hideNavigationMenu: PropTypes.bool,
        pageData: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            // childPages is an array of objects of the same type as pageData,
            // so the nesting of childPages can go down forever...I cant figure
            // out how to define that as a propType so just saying array of objects here
            childPages: PropTypes.arrayOf(PropTypes.object)
        })),
        navigateToPage: PropTypes.func,
        openNavigatorDialog: PropTypes.func,
        closeNavigatorDialog: PropTypes.func,
        leftContent: PropTypes.node,
        rightContent: PropTypes.node
    };
    WebsiteNavigatorWidget.defaultProps = {
        hideNavigationMenu: false
    };
    WebsiteNavigatorWidget.defaultProps = {
        classes: ClassNames
    };
    return WebsiteNavigatorWidget;
}(BaseWidget));
export default WebsiteNavigatorWidget;
